import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Link } from '@abyss/web/ui/Link';
import { Text } from '@abyss/web/ui/Text';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLagoon } from '../../../../hooks/useLagoon';
import { getLagoonConfigValue } from '../../../../utils/providerSearch.utils';
import { adobeLinkTrackEvent } from '../../../AdobeTagging/adobeLinkTrackEvent';
import { mobileOnly } from '../../../ConstantsStyles';
import {
  BenefitContainer,
  BenefitSubHeadingTextStyle,
  BenefitsSubHeadingContainer,
} from './BenefitsList.styled';
import { Divider } from './KeywordSearchDropdown.styled';

export const GymBenefitsList = ({}) => {
  const { t } = useTranslation();
  const allConfigs = useLagoon('config');
  const getGymBenefitUrl = getLagoonConfigValue(allConfigs, 'GYMBENEFIT_URL');
  const isMobileView = useMediaQuery(mobileOnly);

  useEffect(() => {
    adobeLinkTrackEvent({
      name: 'gym benefits impression',
      location: 'body:search input option list:gym benefits',
      destinationUrl: getGymBenefitUrl,
    });
  }, [getGymBenefitUrl]);

  const handleGymBenefitClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!getGymBenefitUrl) {
      return;
    }
    adobeLinkTrackEvent({
      name: 'gym benefits link',
      location: 'body:search input option list:gym benefits',
      destinationUrl: getGymBenefitUrl,
    });
    window.location.assign(getGymBenefitUrl);
  };

  return (
    <React.Fragment>
      <Divider />
      <BenefitContainer>
        <Text
          css={{
            'abyss-text-root': {
              fontFamily: '$link.font-family',
              fontSize: '$link.font-size.default',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '140%',
              letterSpacing: 'var(--web-core-letter-spacing-none, 0)',
            },
          }}
          data-testid="gym-benefits-section-heading"
        >
          {t('COVERAGE_AND_BENEFITS')}
        </Text>
        <BenefitsSubHeadingContainer isMobile={isMobileView}>
          <Text
            css={{
              'abyss-text-root': {
                color:
                  'var(--web-semantic-color-text-interactive-rest-neutral, #323334)',
                fontFamily: '$link.font-family',
                fontSize: '$link.font-size.default',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '140%',
                letterSpacing: 'var(--web-core-letter-spacing-none, 0)',
              },
            }}
          >
            {t('GYM_BENEFIT_TEXT')}
          </Text>
          <BenefitSubHeadingTextStyle>
            <Text
              css={{
                'abyss-text-root': {
                  fontFamily: '$link.font-family',
                  fontSize: '$link.font-size.default',
                  fontStyle: 'normal',
                  lineHeight: '140%',
                  fontWeight: 400,
                  letterSpacing: 'var(--web-core-letter-spacing-none, 0)',
                },
              }}
            >
              {t('GYM_BENEFIT_SUBTEXT')}
            </Text>
            <Link
              css={{
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '140%',
                fontSize: '$link.font-size.default',
              }}
              data-testid="gym-benefit-link"
              hideIcon
              href={getGymBenefitUrl || '#'}
              onClick={handleGymBenefitClick}
            >
              {t('COVERAGE_AND_BENEFITS_LINK')}
            </Link>
          </BenefitSubHeadingTextStyle>
        </BenefitsSubHeadingContainer>
      </BenefitContainer>
    </React.Fragment>
  );
};
